<template>
  <el-dialog
    title="Upload"
    :visible="dialog"
    width="500px"
    top="3vh"
    :modal="true"
    @close="setDialog(false)"
  >
    <el-upload
      drag
      ref="upload"
      :action="`${url}cms/youtube/assets/upload`"
      :headers="headers"
      accept=".mp3"
      :file-list="fileList"
      :on-success="onSuccess"
      :on-change="handleChange"
      name="uploaded"
      multiple
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">
        Drop file here or <em>click to upload</em>
      </div>
      <div class="el-upload__tip" slot="tip">*only mp3 files allowed</div>
    </el-upload>
    <div slot="footer">
      <el-button type="danger" size="mini" @click="setDialog(false)">
        Close
      </el-button>
    </div>
    <!-- <el-button type="primary" @click="upload">Upload</el-button> -->
  </el-dialog>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  data() {
    return {
      fileList: [],
      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
      url: process.env.VUE_APP_ADMIN_API_URL
    }
  },

  computed: {
    ...mapState('youtubeAssets', ['dialog'])
  },

  methods: {
    ...mapMutations('youtubeAssets', ['setDialog']),

    onSuccess() {
      this.setDialog(false)
    },
    handleChange(file, fileList) {
      this.fileList = fileList.slice(-3)
    }
  },

  created() {}
}
</script>
